import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Lore from "@/components/Lore";
import Universe from "@/components/Universe";
import Features from "@/components/Features";
import CharacterShowcase from "@/components/CharacterShowcase";
import Factions from "@/components/Factions";
import Gallery from "@/components/Gallery";
import Stats from "@/components/Stats";
import Faq from "@/components/Faq";
import CtaBanner from "@/components/CtaBanner";
import Footer from "@/components/Footer";

export const PureLife = () => {
  return (
    <main className="bg-[#0B0B0F] text-[#F5F5F5] min-h-screen">
      <Navbar />
      <Hero />
      <Lore />
      <Universe />
      <Features />
      <CharacterShowcase />
      <Factions />
      <Gallery />
      <Stats />
      <Faq />
      <CtaBanner />
      <Footer />
    </main>
  );
};

export default PureLife;
